import { render, staticRenderFns } from "./baseDialog.vue?vue&type=template&id=774ef542&scoped=true&"
import script from "./baseDialog.vue?vue&type=script&lang=js&"
export * from "./baseDialog.vue?vue&type=script&lang=js&"
import style0 from "./baseDialog.vue?vue&type=style&index=0&id=774ef542&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774ef542",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
